import {configureStore} from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import * as Sentry from "@sentry/react";

const isDev = process.env.NODE_ENV !== "production";

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const store = configureStore({
    reducer: rootReducer,
    enhancers: (getDefaultEnhancers) => {
        return getDefaultEnhancers().concat(sentryReduxEnhancer);
    },
    devTools: isDev
});

export type AppState = ReturnType<typeof store.getState>;

export default store;
